module.exports = __webpack_public_path__ + "img/640.d74a310b.png";